export default {"src":"/_next/static/media/circlePencil_40.ec86ee7a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};